<template>
<el-container>
  <el-main class="top-pc">
      <div class="forget-main">
        <div style="max-width: 400px; margin: 0 auto;" :style="{ 'padding-top': `${mainTop}px` }">
          <img src="/static/img/brandmark-design.svg" style="width: 100%;">
        </div>
        <div class="forget-info">
          <div style="padding:6%;">
            <form class="el-form demo-ruleForm forget-form">
              <div style="margin-top:20px;">
                <div class="login-name">{{$t('password')}}</div>
                <div class="el-form-item__content">
                  <div class="el-input">
                    <!-- <el-input type="password" v-model="pwdInput" placeholder="Enter Your Password." show-password></el-input> -->
                    <el-input :type="eyeOpen === true ? 'password' : 'text'" v-model="pwdInput" placeholder="Password" v-on:input="search" @focus="showPassImg = true" @blur="showPassImg === true && pwdInput !== '' ? showPassImg = true : showPassImg = false;checkPassword()" ></el-input>
                    <img :src="eyeOpen === true ? eyeCloseImg : eyeOpenImg" class="eye" v-show="showPassImg" @click="eyeOpen === true ? eyeOpen = false : eyeOpen = true">
                    <span class="email-error" v-show="pwdError">The password requires at least 8 digits.</span>
                  </div>
                </div>
              </div>
              <div style="margin-top:40px;">
                <div class="login-name">Confirm Password</div>
                <div class="el-form-item__content">
                  <div class="el-input">
                    <!-- <el-input type="password" v-model="retypePwdinput" placeholder="Re-enter Your Password." show-password></el-input> -->
                    <el-input :type="reEyeOpen === true ? 'password' : 'text'" v-model="retypePwdinput" placeholder="Re-Password." v-on:input="reSearch" @focus="showRePassImg = true" @blur="showRePassImg === true && retypePwdinput !== '' ? showRePassImg = true : showRePassImg = false;checkRetypePassword()" ></el-input>
                    <img :src="reEyeOpen === true ? eyeCloseImg : eyeOpenImg" class="eye" v-show="showRePassImg" @click="reEyeOpen === true ? reEyeOpen = false : reEyeOpen = true">
                    <span class="email-error" v-show="retypePwdError">The password is inconsistent, please re-enter.</span>
                  </div>
                </div>
              </div>
              <div class="marginTop40" style="width: 100%;">
                <div style="width: 140px; margin: 0 auto;">
                  <el-button class="forget_send" @click="submitForm()" data-index="forget-button" v-if="isDiasbleButton === false">{{resetMsg}}</el-button>
                  <el-button class="forget_send_disabled" data-index="forget-button" v-else>{{resetMsg}}</el-button>
                </div>
              </div>
              <div class="checkPasswordResult" v-if="!checkPasswordResult">
                <div>
                  <img src="/static/img/login/checkLeftSide.svg" class="checkLeftSide">
                </div>
                <div :class="upperCaseLettersResult === true ? 'success': 'error'">
                  <img :src="upperCaseLettersResult === true ? successImg: errorImg"/>
                  <span>contain uppercase letters</span>
                </div>
                <div :class="lowerCaseLettersResult === true ? 'success': 'error'">
                  <img :src="lowerCaseLettersResult === true ? successImg: errorImg"/>
                  <span>contain lowercase letters</span>
                </div>
                <div :class="numberCaseResult === true ? 'success': 'error'">
                  <img :src="numberCaseResult === true ? successImg: errorImg"/>
                  <span>contain numbers</span>
                </div>
                <div :class="specialCharactersResult === true ? 'success': 'error'">
                  <img :src="specialCharactersResult === true ? successImg: errorImg"/>
                  <span>contain special characters</span>
                </div>
                <div :class="charactersLongResult === true ? 'success': 'error'">
                  <img :src="charactersLongResult === true ? successImg: errorImg">
                  <span>at least 8 characters long</span>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
  </el-main>
  <publicFooter></publicFooter>
</el-container>
</template>

<script>
import { emailChangePassword, emailRetype } from '@/request/login.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
export default {
  name: 'resetPassword',
  components: {
    publicFooter,
    publicHeader
  },
  data () {
    return {
      pwdError: false,
      retypePwdError: false,
      checkPasswordResult: true,
      upperCaseLettersResult: '',
      lowerCaseLettersResult: '',
      numberCaseResult: '',
      specialCharactersResult: '',
      charactersLongResult: '',
      successImg: '/static/img/login/checkSuccess.png',
      errorImg: '/static/img/login/checkError.png',
      inputEmail: '',
      pwdInput: '',
      retypePwdinput: '',
      resetMsg: 'Reset Password',
      eyeOpenImg: '/static/img/login/eye-open.png',
      eyeCloseImg: '/static/img/login/eye-close.png',
      showPassImg: false,
      eyeOpen: true,
      showRePassImg: false,
      reEyeOpen: true,
      mainTop: document.documentElement.clientHeight * 0.11,
      isDiasbleButton: false
    }
  },
  created () {
    var reset = this.$route.query.reset
    if (reset === '1') {
      this.resetMsg = 'Reset Password'
    } else {
      this.resetMsg = 'Confirm'
    }
  },
  mounted () {
    this.emailRetype()
  },
  methods: {
    search (event) {
      if (this.pwdInput !== '') {
        this.showPassImg = true
      } else {
        this.showPassImg = false
      }
    },
    reSearch (event) {
      if (this.retypePwdinput !== '') {
        this.showRePassImg = true
      } else {
        this.showRePassImg = false
      }
    },
    checkPassword () {
      var pwdinput = this.pwdInput
      // 检查长度:最少8位.
      this.charactersLongResult = pwdinput.length >= 8
      // 检查大写字母.
      let upperCaseLettersRegex = /[A-Z]/
      this.upperCaseLettersResult = upperCaseLettersRegex.test(pwdinput)
      // 检查小写字母.
      let lowerCaseLettersRegex = /[a-z]/
      this.lowerCaseLettersResult = lowerCaseLettersRegex.test(pwdinput)
      // 检查数字.
      let numbersRegex = /\d/
      this.numberCaseResult = numbersRegex.test(pwdinput)
      // 检查特殊字符.
      // eslint-disable-next-line no-useless-escape
      let specialCharactersRegex = /[!@#$%^&*()_+\-={}\[\]|\\:;"'<>,.?/]/
      this.specialCharactersResult = specialCharactersRegex.test(pwdinput)
      // 检查整体是否符合.
      // eslint-disable-next-line no-useless-escape
      let allRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-={}\[\]|\\:;"'<>,.?/]).{8,}$/
      this.checkPasswordResult = allRegex.test(pwdinput)
      return this.checkPasswordResult
    },
    checkRetypePassword () {
      this.retypePwdError = this.pwdInput !== this.retypePwdinput
    },
    submitForm () {
      if (this.checkPasswordResult === false || this.checkPasswordResult === 'false') {
        return ''
      }
      this.isDiasbleButton = true
      this.pwdError = false
      this.retypePwdError = false
      var pwdinput = this.pwdInput
      var retypePwdinput = this.retypePwdinput
      var source = this.$route.query.source
      let from = this.$route.query.from
      if (from === undefined) {
        from = ''
      }
      // if (!this.checkPassword()) {
      //   return ''
      // }
      if (pwdinput !== retypePwdinput) {
        this.retypePwdError = true
        this.isDiasbleButton = false
        return ''
      }
      var sessionid = this.common.sessionidGet(this)
      var time = parseInt(new Date().getTime() / 1000)
      var dataJson = {
        'email': this.inputEmail,
        'password': pwdinput,
        'retypePassword': retypePwdinput,
        'time': time,
        'sessionid': sessionid,
        'source': source,
        'from': from,
        'operation': 'emailChangePassword',
        'searchsign': this.$route.query.sign ? this.$route.query.sign : '',
        'searchtime': this.$route.query.time ? this.$route.query.time : '',
        'searchsource': this.$route.query.source ? this.$route.query.source : ''
      }
      var data = this.common.encryptionData(dataJson, this)
      emailChangePassword(data).then(res => {
        if (res.flag === '124') {
          this.retypePwdError = true
          this.isDiasbleButton = false
        } else if (res.flag === '200') {
          this.$message.success('The password has been successfully updated.')
          this.isDiasbleButton = false
          setTimeout(() => {
            this.$router.push({name: 'login'})
          }, 2000)
        } else {
          this.$message.error(res.msg)
          this.isDiasbleButton = false
        }
      })
    },
    emailRetype: function () {
      var email = this.$route.query.email
      var searchtime = this.$route.query.time
      var searchsign = this.$route.query.sign
      var searchsource = this.$route.query.source
      if (searchsign === undefined) {
        return ''
      }
      var sessionid = this.common.sessionidGet(this)
      var time = parseInt(new Date().getTime() / 1000)
      var dataJson = {
        'email': email,
        'searchsign': searchsign,
        'searchtime': searchtime,
        'searchsource': searchsource,
        'time': time,
        'sessionid': sessionid,
        'operation': 'emailRetype'
      }
      var data = this.common.encryptionData(dataJson, this)
      emailRetype(data).then(res => {
        if (res.flag === '101') {
          this.$message.error('Oops! It looks like this reset link has expired. Please request a new one. We apologize for any inconvenience.')
          setTimeout(() => {
            this.$router.push({name: 'login'})
          }, 3000)
        } else if (res.flag === '200') {
          this.inputEmail = res.data.email
        } else {
          this.pwdError = true
          this.retypePwdError = true
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.el-main{background-color: rgba(83, 102, 163, 0.2);}
.forget-main{background-color: rgba(83, 102, 163, 0.2);width:100%;min-height: 560px; margin:0 auto;height: 100vh;}
.forget-info{width: 520px;margin: -100px auto 0 auto;background-color: rgba(255, 255, 255, 0.6);border: none;border-radius: 5px;}
.forgettext{font-weight: 650;font-size: 24px; height: 60px;background-color: rgba(255, 255, 255, 0);box-sizing: border-box;border-bottom: 1px solid rgba(221, 223, 226, 1);}
.forget-form{margin:15px 0px; color:#606266;font-size: 14px;}
.forget-form input{ margin-top:10px;}
.forget_send, .forget_send_active{width: 140px;height: 44px; font-size:14px; background-color: rgba(83, 102, 163, 1);box-sizing: border-box;border: 1px solid rgba(83, 102, 163, 1);border-radius: 5px;color: #FFFFFF;margin-top:30px;}
.forget_send:hover{border: 1px solid rgba(83, 102, 163, 1) !important;background-color: #FFF;color: rgba(83, 102, 163, 1); }
.forget_send_disabled, .forget_send_disabled:hover, .forget_send_disabled:focus{width: 140px;height: 44px; font-size:14px; background-color: #D7D7D7; box-sizing: border-box; border:1px solid #D7D7D7; border-radius: 5px; cursor: no-drop; margin-top:30px; color: #FFF;}
.forget-other{ text-align:center;}
.forget-other a{ font-size:14px; color:#5392F9;text-decoration-line: none;}
/deep/ .el-input__inner:focus{border-color:rgba(83, 102, 163, 1);box-shadow:0px 0px 8px rgba(83, 102, 163, 1);}
.email-error{color: #FF001F; font-size: 10px;display: block;position: absolute;top: 35px;}
.forget-info /deep/ .el-input__inner{padding: 0 45px 0 15px;}
.eye{height: 15px; width: 15px; position: absolute;top: 12.5px; right: 15px; cursor: pointer;}
/*密码检查样式*/
.checkPasswordResult {box-sizing: border-box;box-shadow: 2px 2px 12px 0px rgba(170, 170, 170, 0.35);position: relative;right: -195px;top: -214px;background-color: #FFFFFF;padding: 10px;font-size: 14px;border-radius: 5px;float: right;}
.checkPasswordResult .success img,.checkPasswordResult .error img{width: 14px; height: 14px;vertical-align: middle;}
.checkPasswordResult span{font-size: 12px;line-height: 1;vertical-align: middle;}
.checkPasswordResult .success{color: #43A048}
.checkPasswordResult .error{color:#FE5353}
.checkLeftSide {position:absolute;left:-11px; top:15px;width: 17px;height:10px;transform: rotate(270deg);padding: 2px 2px 2px 2px;box-sizing: border-box;}
@media only screen and (min-width:431px) and (max-width:600px) {
  .forget-info{width: 420px;
    margin: 0 auto;
    margin-top: -100px;
    background-color: rgba(255, 255, 255, 0.6);
    border: none;
    border-radius: 5px;
  }
  .checkPasswordResult {box-sizing: border-box;box-shadow: 2px 2px 12px 0px rgba(170, 170, 170, 0.35);position: relative;left: 0px;top: -166px;background-color: #FFFFFF;padding: 10px;font-size: 14px;border-radius: 5px;float: right;}
  .checkLeftSide {position:absolute;left:9px; top:-8px;width: 17px;height:10px;transform: rotate(360deg);padding: 2px 2px 2px 2px;box-sizing: border-box;}
}
@media only screen and (min-width:391px) and (max-width:430px) {
  .forget-info{width: 380px;
    margin: 0 auto;
    margin-top: -100px;
    background-color: rgba(255, 255, 255, 0.6);
    border: none;
    border-radius: 5px;
  }
  .checkPasswordResult {box-sizing: border-box;box-shadow: 2px 2px 12px 0px rgba(170, 170, 170, 0.35);position: relative;left: 0px;top: -166px;background-color: #FFFFFF;padding: 10px;font-size: 14px;border-radius: 5px;float: right;}
  .checkLeftSide {position:absolute;left:9px; top:-8px;width: 17px;height:10px;transform: rotate(360deg);padding: 2px 2px 2px 2px;box-sizing: border-box;}
}
@media only screen and (max-width:390px) {
  .forget-info{width: 350px;
    margin: 0 auto;
    margin-top: -100px;
    background-color: rgba(255, 255, 255, 0.6);
    border: none;
    border-radius: 5px;
  }
  .checkPasswordResult {box-sizing: border-box;box-shadow: 2px 2px 12px 0px rgba(170, 170, 170, 0.35);position: relative;left: 0px;top: -166px;background-color: #FFFFFF;padding: 10px;font-size: 14px;border-radius: 5px;float: right;}
  .checkLeftSide {position:absolute;left:9px; top:-8px;width: 17px;height:10px;transform: rotate(360deg);padding: 2px 2px 2px 2px;box-sizing: border-box;}
}
</style>



// WEBPACK FOOTER //
// src/components/login/resetPassword.vue